<div class="padding">
  <form [formGroup]="lienDetails">
    <app-term [uiConfiguration]="uiConfiguration.lienDetailsConfiguration!" [isDisabled]="isDisabled" [order]="order" [errors$]="observableErrors$"></app-term>

    @if (uiConfiguration.lienDetailsConfiguration?.showAmount) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'common.labels.amount' | transloco }}</mat-label>
            <input matInput data-testid="amount-field" [placeholder]="'common.labels.amount' | transloco" [formControlName]="'amount'" type="number">
          </mat-form-field>
          <lib-error-bubble [control]="lienDetails.controls['amount']"
          [message]="amountError$"></lib-error-bubble>
        </div>
      </div>
    }

    @if (uiConfiguration.lienDetailsConfiguration?.showRIN) {
      <div class="flex-container padding-top">
        <div class="flex-item form-field">
          <mat-radio-group formControlName="customRin" name="rin-radio"
            [attr.aria-label]="'orders.lienTermOrInfiniteLienRadio' | transloco">
            <mat-radio-button class="radio-button" data-testid="no-rin-radio-button" [value]="'no'">{{ getNoRINText() }}</mat-radio-button>
            <mat-radio-button class="radio-button" data-testid="choose-rin-radio-button" [value]="'choose'">{{ getChooseRINText() }}</mat-radio-button>
            @if (shouldShowSystemGeneratedRIN()) {
              <mat-radio-button class="radio-button" data-testid="registry-rin-radio-button" [value]="'system'">{{ 'orders.generateRinAtRegistry' | transloco }}</mat-radio-button>
            }
          </mat-radio-group>
        </div>
      </div>
    }

    @if (uiConfiguration.lienDetailsConfiguration?.showRIN && lienDetails.get('customRin')!.value === 'choose') {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'orders.rin' | transloco }}</mat-label>
            <input matInput data-testid="rin-field" [placeholder]="'orders.rin' | transloco" formControlName="rin">
          </mat-form-field>
          <lib-error-bubble [control]="lienDetails.controls['rin']" [message]="rinError$"></lib-error-bubble>
        </div>
      </div>
    }

    @if (uiConfiguration.lienDetailsConfiguration?.showTrustIndenture) {
      <div class="flex-container flex-item padding-top">
        <div class="validated-form-field-container flex-container">
          <mat-checkbox class="flex-item" formControlName="trustIndenture" data-testid="trust-indenture-checkbox">
            {{ 'orders.trustIndenture' | transloco }}
          </mat-checkbox>
        </div>
        <lib-error-bubble [control]="lienDetails.controls['trustIndenture']" [message]="trustIndentureError$"></lib-error-bubble>
      </div>
    }
  </form>
</div>